import React from 'react';
import { ComponentWrapper } from '../../../../helperComponents/componentWrapper/ComponentWrapper';
import sharedStyles from '../../Shared/styles';
import { Header } from './Header';
import { StyleSheet, Text, View } from 'react-native';
import {
    mbApplyTransparency,
    mbTextStyles,
} from '@mightybyte/rnw.utils.style-utils';
import { FONT_STYLES, textStyles } from '../../../../../constants/textStyles';
import { ShadowView } from '../../../../helperComponents/ShadowView';

export default function About() {
    return (
        <ComponentWrapper
            innerContainerStyle={sharedStyles.container}
            wrapInScrollView={false}
        >
            <Header title="ABOUT" />
            <View style={styles.content}>
                <Text style={styles.titleText}>About Us</Text>
                <ShadowView style={styles.note}>
                    <Text style={styles.noteText}>
                        Sapphic Savvy is the not-for-profit, grant-funded
                        project of a group of lesbian and queer psychologists
                        based in Los Angeles. We are in our 20s, 30s, 40s, and
                        50s and you will see us playing along each quarter! We
                        created the app to be something fun and helpful to the
                        sapphic community in the context of the super stressful
                        and divisive hellscape in which we find ourselves. Seems
                        like a great time to challenge negative sapphic
                        stereotypes, test our assumptions about one another,
                        foster community connection, and link us up with
                        resources to support our well-being (and sanity).
                    </Text>
                </ShadowView>
            </View>
        </ComponentWrapper>
    );
}

const styles = StyleSheet.create({
    content: {
        paddingTop: 50,
        paddingHorizontal: 15,
    },
    titleText: mbTextStyles([
        textStyles.normalText,
        {
            fontFamily: FONT_STYLES.Tabasco_400,
            fontWeight: '400',
            fontSize: 25,
            color: '#000000',
            marginBottom: 20,
        },
    ]),
    messageText: mbTextStyles([
        textStyles.normalText,
        {
            fontWeight: '400',
            color: mbApplyTransparency('#6D6E71', 0.96),
            marginBottom: 40,
            marginTop: 5,
        },
    ]),
    note: {
        paddingHorizontal: 25,
        paddingVertical: 30,
    },
    noteText: mbTextStyles([
        textStyles.smallText,
        {
            color: mbApplyTransparency('#000000', 0.85),
            textAlign: 'left',
        },
    ]),
    mailText: {
        color: '#FF3737',
    },
});
